import React from 'react';
import DatasetCatalogueTabList from './DatasetCatalogueTabFieldList';
import CatalogueFieldListStatusDates from './CatalogueFieldListStatusDates';
import DatasetCatalogueAccordionFieldList from './DatasetCatalogueAccordionFieldList';

const DatasetCatalogueMiddle = ({
  asTab,
  category,
  code,
  direction,
  index = 0,
  panel = 'middle',
  url,
}) => {
  const Component = asTab ? DatasetCatalogueTabList : DatasetCatalogueAccordionFieldList;

  return (
    <Component
      category={category}
      code={code}
      direction={direction}
      index={index}
      panel={panel}
      section="second"
      url={url}
    >
      <CatalogueFieldListStatusDates code={code} category={category} />
    </Component>
  );
};

export default DatasetCatalogueMiddle;
